import React from "react";
import styles from "./footer.module.css";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getUIText } from "../../translation";

export default function Footer() {
    const location = useLocation();
    const lang = useSelector((state) => state.lang.value);

    return (
        <div id="footer-container" className={`${styles["app-footer"]} ${location.pathname === "/" ? `${styles["main"]}` : ""}`}>
            <p>{getUIText(lang, "footer.text.1")}</p>
            <p>{getUIText(lang, "footer.text.2")}</p>
            <p>{getUIText(lang, "footer.text.3")}</p>
            <p>{getUIText(lang, "footer.text.4")}</p>
            <div className="hits-counter" style={{ marginTop: "10px" }}>
                <a href="https://myhits.vercel.app">
                    <img
                        src="https://myhits.vercel.app/api/hit/https%3A%2F%2Fkanohban.github.io%2FStarSaviorArcanaDB%2F?color=blue&amp;label=hits&amp;size=small"
                        alt="hits"
                    />
                </a>
            </div>
        </div>
    );
}
